export enum AzureFolderContainer {
  ContainerPublisherDrafts = 'publisher-drafts',
  FolderContracts = 'contracts',
  ContainerComponentsImages = 'components-images',
}
